module.exports = __webpack_public_path__ + "img/mono-rounded.9d4ed942.svg";